import { render } from "./HistoryPlan.vue?vue&type=template&id=771c1a15"
import script from "./HistoryPlan.vue?vue&type=script&lang=js"
export * from "./HistoryPlan.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__